































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { api as deskApi } from "../store/modules/desk";
import { FriendRef } from "@dokogd/shared";
@Component({})
export default class DoKoSpectators extends Vue {
  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  get transformText(): string {
    return `translate(${this.x} ${this.y})`;
  }

  @Getter(deskApi.getters.getSpectators, { namespace: deskApi.namespace })
  spectators!: FriendRef[];
}
